(() => {
  function init(section) {
    if (section.dataset.initialized) return;
    section.dataset.initialized = 'true';
    const cards = section.querySelector('[data-collection-cards]');
    const pagination = section.querySelector('[data-grid-pagination]');
    const status = section.querySelector('[data-grid-status]');
    const pageSize = section.querySelector('[data-page-size]');
    const sort = section.querySelector('[data-collection-sort]');
    const sidebar = section.querySelector('.collection-grid__sidebar');
    const openFilter = section.querySelector('[data-filter-open]');
    const backdrop = section.querySelector('.collection-grid__backdrop');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const design = getComputedStyle(section);
    const motionDuration = parseFloat(design.getPropertyValue('--cg-motion-speed')) || 0;
    const gridDuration = parseFloat(design.getPropertyValue('--cg-grid-motion-speed')) || 0;
    sidebar.querySelectorAll('details').forEach(details => {
      const summary = details.querySelector('summary');
      const content = document.createElement('div');
      content.className = 'collection-grid__filter-content';
      while (summary.nextSibling) content.append(summary.nextSibling);
      details.append(content);
      let expanded = details.open;
      let animation;
      summary.setAttribute('aria-expanded', String(expanded));
      summary.addEventListener('click', event => {
        event.preventDefault();
        const from = details.open ? content.getBoundingClientRect().height : 0;
        if (animation) { animation.onfinish = null; animation.cancel(); }
        expanded = !expanded;
        summary.setAttribute('aria-expanded', String(expanded));
        content.inert = !expanded;
        if (reduced.matches) { details.open = expanded; return; }
        details.open = true;
        const to = expanded ? content.getBoundingClientRect().height : 0;
        animation = content.animate([{ height: `${from}px`, opacity: expanded ? 0 : 1 }, { height: `${to}px`, opacity: expanded ? 1 : 0 }], { duration: motionDuration, easing: 'ease', fill: 'both' });
        animation.onfinish = () => { details.open = expanded; animation.cancel(); animation = null; };
      });
    });
    const mobile = matchMedia('(max-width: 749px)');
    sidebar.inert = mobile.matches;
    let filterOpener;
    let request;
    let page = Number(new URL(location.href).searchParams.get('page')) || 1;
    let size = Number(new URL(location.href).searchParams.get('limit')) || parseInt(design.getPropertyValue('--cg-default-page-size')) || 20;
    if (![20, 40, 60].includes(size)) size = 20;
    pageSize.value = String(size);
    function enhanceSelect(select) {
      const isSort = select === sort;
      const label = select.closest('label');
      const wrapper = document.createElement('div');
      wrapper.className = 'collection-grid__select';
      const trigger = document.createElement('button');
      trigger.type = 'button'; trigger.className = 'collection-grid__select-trigger';
      trigger.setAttribute('aria-haspopup', 'listbox'); trigger.setAttribute('aria-expanded', 'false');
      trigger.setAttribute('aria-label', select.closest('label').childNodes[0].textContent.trim());
      const panel = document.createElement('div');
      panel.className = 'collection-grid__select-panel'; panel.inert = true;
      const list = document.createElement('div'); list.setAttribute('role', 'listbox');
      const shade = document.createElement('button'); shade.type = 'button'; shade.className = 'collection-grid__sort-backdrop'; shade.tabIndex = -1; shade.setAttribute('aria-label', label.dataset.closeLabel || 'Close');
      if (isSort) {
        wrapper.classList.add('collection-grid__select--sort');
        const header = document.createElement('div'); header.className = 'collection-grid__sort-heading';
        const heading = document.createElement('strong'); heading.textContent = label.dataset.sheetHeading;
        const dismiss = document.createElement('button'); dismiss.type = 'button'; dismiss.className = 'collection-grid__sort-close'; dismiss.setAttribute('aria-label', label.dataset.closeLabel); const closeIcon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        closeIcon.setAttribute('viewBox', '0 0 24 24'); closeIcon.setAttribute('aria-hidden', 'true'); closeIcon.setAttribute('focusable', 'false');
        const closePath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        closePath.setAttribute('d', 'M3 3l18 18M21 3L3 21'); closePath.setAttribute('fill', 'none'); closePath.setAttribute('stroke', 'currentColor'); closePath.setAttribute('stroke-width', '1.5');
        closeIcon.append(closePath); dismiss.append(closeIcon); dismiss.addEventListener('click', () => { close(); trigger.focus(); });
        header.append(heading, dismiss); panel.append(header); shade.addEventListener('click', () => { close(); trigger.focus(); });
      }
      panel.append(list);
      panel.id = `CollectionSelect-${section.dataset.sectionId}-${select === pageSize ? 'size' : 'sort'}`;
      trigger.setAttribute('aria-controls', panel.id);
      const options = [...select.options].map(option => {
        const button = document.createElement('button'); button.type = 'button'; button.textContent = option.text;
        button.setAttribute('role', 'option'); button.tabIndex = -1;
        button.addEventListener('click', () => { select.value = option.value; sync(); close(); trigger.focus(); select.dispatchEvent(new Event('change', { bubbles: true })); });
        list.append(button); return button;
      });
      function sync() { trigger.textContent = isSort && mobile.matches ? label.dataset.mobileLabel : select.selectedOptions[0]?.text || ''; options.forEach((option, index) => option.setAttribute('aria-selected', String(index === select.selectedIndex))); }
      function close() { wrapper.classList.remove('is-open'); panel.inert = true; trigger.setAttribute('aria-expanded', 'false'); panel.removeAttribute('role'); panel.removeAttribute('aria-modal'); if (isSort) document.body.classList.remove('collection-sort-open'); }
      function open() {
        section.querySelectorAll('.collection-grid__select.is-open .collection-grid__select-trigger').forEach(other => { if (other !== trigger) other.click(); });
        if (isSort && mobile.matches) { setFilters(false); document.body.classList.add('collection-sort-open'); panel.setAttribute('role', 'dialog'); panel.setAttribute('aria-modal', 'true'); panel.setAttribute('aria-label', label.dataset.sheetHeading); }
        panel.inert = false; wrapper.classList.add('is-open'); trigger.setAttribute('aria-expanded', 'true'); options[select.selectedIndex]?.focus();
      }
      trigger.addEventListener('click', () => wrapper.classList.contains('is-open') ? close() : open());
      wrapper.addEventListener('keydown', event => {
        if (event.key === 'Escape') { event.preventDefault(); close(); trigger.focus(); }
        if (event.key === 'Tab' && isSort && mobile.matches && wrapper.classList.contains('is-open')) {
          event.preventDefault(); const targets = [...panel.querySelectorAll('button')]; const index = targets.indexOf(document.activeElement); targets[(index + (event.shiftKey ? -1 : 1) + targets.length) % targets.length].focus();
        }
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          if (!wrapper.classList.contains('is-open')) { open(); return; }
          const index = options.indexOf(document.activeElement);
          options[(index + (event.key === 'ArrowDown' ? 1 : -1) + options.length) % options.length].focus();
        }
        if (event.key === 'Home' || event.key === 'End') { event.preventDefault(); options[event.key === 'Home' ? 0 : options.length - 1].focus(); }
      });
      wrapper.addEventListener('focusout', event => { if (!wrapper.contains(event.relatedTarget)) close(); });
      document.addEventListener('click', event => { if (!wrapper.contains(event.target)) close(); });
      select.addEventListener('change', sync);
      mobile.addEventListener('change', () => { close(); sync(); });
      select.after(wrapper); if (isSort) wrapper.append(shade); wrapper.append(trigger, panel); select.hidden = true; sync();
      return sync;
    }
    const syncPageSize = enhanceSelect(pageSize);
    const syncSort = enhanceSelect(sort);
    function setFilters(open) {
      section.classList.toggle('filters-open', open);
      backdrop.hidden = !open;
      sidebar.inert = mobile.matches && !open;
      if (mobile.matches && open) { sidebar.setAttribute('role', 'dialog'); sidebar.setAttribute('aria-modal', 'true'); }
      else { sidebar.removeAttribute('role'); sidebar.removeAttribute('aria-modal'); }
      openFilter.setAttribute('aria-expanded', String(open));
      if (open) { filterOpener = document.activeElement; document.body.classList.add('drawer-open'); sidebar.querySelector('button').focus(); }
      else { document.body.classList.remove('drawer-open'); filterOpener?.focus(); }
    }
    openFilter.addEventListener('click', () => setFilters(true));
    mobile.addEventListener('change', () => { setFilters(false); sidebar.inert = mobile.matches; });
    section.querySelectorAll('[data-filter-close]').forEach(button => button.addEventListener('click', () => setFilters(false)));
    section.addEventListener('keydown', event => {
      if (!section.classList.contains('filters-open')) return;
      if (event.key === 'Escape') setFilters(false);
      if (event.key === 'Tab') {
        const focusable = [...sidebar.querySelectorAll('a,button,input,summary')].filter(e => !e.disabled && e.getClientRects().length);
        if (event.shiftKey && document.activeElement === focusable[0]) { event.preventDefault(); focusable.at(-1).focus(); }
        else if (!event.shiftKey && document.activeElement === focusable.at(-1)) { event.preventDefault(); focusable[0].focus(); }
      }
    });
    function syncGridControls() {
      const active = section.classList.contains('is-list') ? 1 : mobile.matches ? 2 : Number(section.style.getPropertyValue('--grid-columns'));
      section.querySelectorAll('[data-grid-columns]').forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.gridColumns) === active)));
    }
    syncGridControls(); mobile.addEventListener('change', syncGridControls);
    section.querySelectorAll('[data-grid-columns]').forEach(button => button.addEventListener('click', () => {
      const columns = Number(button.dataset.gridColumns);
      const positions = [...cards.children].map(card => ({ card, rect: card.getBoundingClientRect() }));
      section.style.setProperty('--grid-columns', columns);
      section.classList.toggle('is-list', columns === 1);
      section.querySelectorAll('[data-grid-columns]').forEach(control => control.setAttribute('aria-pressed', String(control === button)));
      if (!reduced.matches) positions.forEach(({ card, rect }) => {
        const next = card.getBoundingClientRect();
        card.animate([{ transform: `translate(${rect.x - next.x}px,${rect.y - next.y}px)`, opacity: .5 }, { transform: 'translate(0,0)', opacity: 1 }], { duration: gridDuration, easing: 'ease' });
      });
    }));
    function renderPagination(total) {
      pagination.replaceChildren();
      const pages = Math.ceil(total / size);
      for (let number = 1; number <= pages; number++) {
        const button = document.createElement('button'); button.type = 'button'; button.textContent = number;
        if (number === page) button.setAttribute('aria-current', 'page');
        button.addEventListener('click', () => load(number)); pagination.append(button);
      }
    }
    async function load(nextPage, updateUrl = true) {
      request?.abort(); request = new AbortController();
      const signal = request.signal;
      cards.setAttribute('aria-busy', 'true'); status.textContent = section.dataset.loading;
      const url = new URL(location.href); url.searchParams.set('sort_by', sort.value); url.searchParams.set('limit', size); url.searchParams.set('page', nextPage);
      const firstServerPage = (nextPage - 1) * (size / 20) + 1;
      try {
        const requestCount = Math.min(size / 20, Math.max(1, Math.ceil(Number(section.dataset.total) / 20) - firstServerPage + 1));
        const results = await Promise.all(Array.from({ length: requestCount }, async (_, index) => {
          const endpoint = new URL(url); endpoint.searchParams.set('section_id', section.dataset.sectionId); endpoint.searchParams.set('page', firstServerPage + index);
          const response = await fetch(endpoint, { signal });
          if (!response.ok) throw new Error('Products could not be loaded. Please try again.');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const result = doc.querySelector('[data-collection-grid]');
          if (!result) throw new Error('Products could not be loaded. Please refresh the page.');
          return result;
        }));
        if (signal.aborted) return;
        const items = results.flatMap(result => [...result.querySelectorAll('[data-collection-card]')]);
        cards.replaceChildren(...items);
        if (!items.length) { const empty = document.createElement('p'); empty.textContent = section.dataset.empty; cards.append(empty); }
        page = nextPage; section.dataset.total = results[0].dataset.total;
        renderPagination(Number(section.dataset.total));
        if (updateUrl) history.pushState({}, '', url);
        status.textContent = '';
        if (!reduced.matches) cards.animate([{ opacity: .3 }, { opacity: 1 }], { duration: gridDuration });
      } catch (error) { if (error.name !== 'AbortError') status.textContent = error.message; }
      finally { if (!signal.aborted) cards.setAttribute('aria-busy', 'false'); }
    }
    pageSize.addEventListener('change', () => { size = Number(pageSize.value); load(1); });
    sort.addEventListener('change', () => { section.querySelectorAll('input[name="sort_by"]').forEach(input => { input.value = sort.value; }); load(1); });
    pagination.addEventListener('click', event => {
      const link = event.target.closest('a'); if (!link) return;
      event.preventDefault(); load(Number(new URL(link.href).searchParams.get('page')) || 1);
    });
    window.addEventListener('popstate', () => {
      const url = new URL(location.href); size = Number(url.searchParams.get('limit')) || 20;
      pageSize.value = String(size); sort.value = url.searchParams.get('sort_by') || sort.querySelector('[selected]')?.value || sort.value;
      syncPageSize(); syncSort();
      load(Number(url.searchParams.get('page')) || 1, false);
    });
    if (size !== 20) load(page, false);
    section.addEventListener('submit', async event => {
      const form = event.target.closest('[data-collection-cart]'); if (!form) return;
      event.preventDefault(); const button = form.querySelector('button'); button.disabled = true; button.classList.add('is-loading'); button.setAttribute('aria-busy', 'true');
      status.textContent = section.dataset.adding;
      try {
        const response = await fetch(`${section.dataset.cartUrl}.js`, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'Could not add this product.');
        status.textContent = section.dataset.added;
        if (window.ORCartDrawer) { await window.ORCartDrawer.open(button); }
        const cartResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`);
        if (cartResponse.ok) { const cart = await cartResponse.json(); document.querySelectorAll('.site-header__cart-count').forEach(count => { count.textContent = cart.item_count; count.closest('a').setAttribute('aria-label', `Cart, ${cart.item_count} items`); }); }
      } catch (error) { status.textContent = error.message; }
      finally { button.disabled = false; button.classList.remove('is-loading'); button.removeAttribute('aria-busy'); }
    });
  }
  function boot() { document.querySelectorAll('[data-collection-grid]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
